/**
 * Created by i.lovenkov on 26.10.16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    MiniBasketView: {
        displayName: 'MiniBasketView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/MiniBasket/default/MiniBasketView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var MiniBasketView = _wrapComponent('MiniBasketView')(function (_Component) {
    (0, _inherits3.default)(MiniBasketView, _Component);

    function MiniBasketView() {
        (0, _classCallCheck3.default)(this, MiniBasketView);
        return (0, _possibleConstructorReturn3.default)(this, (MiniBasketView.__proto__ || (0, _getPrototypeOf2.default)(MiniBasketView)).apply(this, arguments));
    }

    (0, _createClass3.default)(MiniBasketView, [{
        key: 'render',
        value: function render() {
            var length = this.props.length;

            var isActive = length ? " active_icon" : "";
            return _react3.default.createElement(
                _reactRouter.Link,
                { to: '/basket', className: 'ibonus-shopping-cart' },
                _react3.default.createElement(
                    'div',
                    { className: 'header_icon-holder' },
                    _react3.default.createElement('i', { className: "fa fa-shopping-cart header_icon " + isActive }),
                    length ? _react3.default.createElement(
                        'div',
                        { className: 'header_icon_text-holder' },
                        _react3.default.createElement(
                            'span',
                            { className: 'header_icon_text' },
                            length
                        )
                    ) : null
                )
            );
        }
    }]);
    return MiniBasketView;
}(_react2.Component));

exports.default = MiniBasketView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MiniBasket/default/MiniBasketView.jsx
// module id = 1687
// module chunks = 0